import { recordingRequirementsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RECORDING_REQUIREMENTS_ACTION_TYPE = createNamedActions('recording-requirements', {
  GET_SCOPES: 'GET_SCOPES',
  GET_EFFECTIVE: 'GET_EFFECTIVE',
  CLEAR_EFFECTIVE: 'CLEAR_EFFECTIVE',
  RESET_RECORDING_REQUIREMENTS_STATE: 'RESET_RECORDING_REQUIREMENTS_STATE',
});

export const getRecordingRequirementScopesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await recordingRequirementsApi.getScopes({ includeGlobal: true });

  return dispatch({
    type: RECORDING_REQUIREMENTS_ACTION_TYPE.GET_SCOPES,
    payload: data ?? [],
  });
});

export const getEffectiveRecordingRequirementsAction = catchAsyncActionError(
  ({ stateCode, countyFips }) =>
    async dispatch => {
      const { data } = await recordingRequirementsApi.getRecordingRequirements({
        state: stateCode,
        countyFips,
      });

      return dispatch({
        type: RECORDING_REQUIREMENTS_ACTION_TYPE.GET_EFFECTIVE,
        payload: data ?? null,
      });
    },
);

export const clearEffectiveRecordingRequirementsAction = () => ({
  type: RECORDING_REQUIREMENTS_ACTION_TYPE.CLEAR_EFFECTIVE,
});

export const createRecordingRequirementScopeAction = catchAsyncActionError(body => async () => {
  const { data } = await recordingRequirementsApi.createScope(body);

  return data;
});

export const updateRecordingRequirementScopeAction = catchAsyncActionError(
  ({ id, ...body }) =>
    async () => {
      const { data } = await recordingRequirementsApi.updateScope({ id, ...body });

      return data;
    },
);

export const deleteRecordingRequirementScopeAction = catchAsyncActionError(({ id }) => async () => {
  await recordingRequirementsApi.deleteScope({ id });
});

export const resetRecordingRequirementsStateAction = () => ({
  type: RECORDING_REQUIREMENTS_ACTION_TYPE.RESET_RECORDING_REQUIREMENTS_STATE,
});
